module.exports = __webpack_public_path__ + "static/assets/c887aacf6ccff00ee9daa4688f55d1e6.svg";